import { debitNote as debitNoteEn } from '../en/debitNote';

export const debitNote = {
  ...debitNoteEn,
  debitNotes: 'டெபிட் குறிப்புகள்',
  allDebitNotes: 'அனைத்து டெபிட் குறிப்புகள்',
  createDebitNote: 'டெபிட் குறிப்பை வழங்கவும்',
  debitNoteDetails: 'டெபிட் குறிப்பு விவரங்கள்',
  status_issued: 'வழங்கப்பட்டது',
  status_applied: 'பயன்படுத்தப்பட்டது',
  status_cancelled: 'ரத்து செய்யப்பட்டது',

  // Apply to a purchase order of the same supplier
  applyAmountExceedsPurchaseOrderBalance: 'தொகை தேர்ந்தெடுக்கப்பட்ட கொள்முதல் ஆர்டரின் நிலுவைத் தொகையை மீறுகிறது',
  viewAndManageAllDebitNotes: "அனைத்து டெபிட் குறிப்புகளையும் பார்த்து நிர்வகிக்கவும்",
  createDebitNoteDescription: "சப்ளையர் கொள்முதல் ஆர்டருக்கு எதிராக டெபிட் குறிப்பை கைமுறையாக வழங்கவும்",
  debitNoteNumber: "டெபிட் குறிப்பு எண்",
  supplier: "சப்ளையர்",
  purchaseOrderNumber: "கொள்முதல் ஆர்டர்",
  purchaseOrderBalance: "ஆர்டர் நிலுவை",
  sourceType: "மூலம்",
  amount: "தொகை",
  appliedAmount: "பயன்படுத்திய தொகை",
  remainingAmount: "மீதமுள்ள தொகை",
  status: "நிலை",
  createdAt: "உருவாக்கப்பட்ட தேதி",
  actions: "செயல்கள்",
  debitNoteDetailsTitle: "டெபிட் குறிப்பு விவரங்கள்",
  offsetPayments: "ஈடுசெய் கட்டணங்கள்",
  sourceReturnToVendor: "மூல சப்ளையர் திரும்பல்",
  sourceType_return_to_vendor: "சப்ளையருக்குத் திரும்பல்",
  sourceType_price_adjustment: "விலை சரிசெய்தல்",
  sourceType_correction: "திருத்தம்",
  selectSupplier: "சப்ளையரைத் தேர்ந்தெடுக்கவும்",
  allSuppliers: "அனைத்து சப்ளையர்கள்",
  purchaseOrder: "கொள்முதல் ஆர்டர்",
  selectPurchaseOrder: "கொள்முதல் ஆர்டரைத் தேர்ந்தெடுக்கவும்",
  purchaseOrderIdPlaceholder: "கொள்முதல் ஆர்டர் ID ஐ உள்ளிடவும்",
  amountPlaceholder: "தொகையை உள்ளிடவும்",
  reason: "காரணம்",
  reasonPlaceholder: "இந்த டெபிட் குறிப்பை வழங்குவதற்கான காரணம்...",
  applyAmountLabel: "பயன்படுத்த வேண்டிய தொகை",
  create: "டெபிட் குறிப்பை வழங்கவும்",
  applyDebitNote: "டெபிட் குறிப்பைப் பயன்படுத்தவும்",
  cancelDebitNote: "டெபிட் குறிப்பை ரத்து செய்யவும்",
  print: "அச்சிடு",
  printDebitNote: "டெபிட் குறிப்பை அச்சிடவும்",
  backToDebitNotes: "டெபிட் குறிப்புகளுக்குத் திரும்பு",
  confirmCancelDebitNote: "இந்த டெபிட் குறிப்பை ரத்து செய்ய விரும்புகிறீர்களா?",
  filterBySupplier: "சப்ளையர் மூலம் வடிகட்டு",
  filterByPurchaseOrder: "கொள்முதல் ஆர்டர் மூலம் வடிகட்டு",
  debitNoteCreatedSuccessfully: "டெபிட் குறிப்பு {number} வெற்றிகரமாக வழங்கப்பட்டது",
  debitNoteAppliedSuccessfully: "டெபிட் குறிப்பு வெற்றிகரமாகப் பயன்படுத்தப்பட்டது",
  debitNoteCancelledSuccessfully: "டெபிட் குறிப்பு வெற்றிகரமாக ரத்து செய்யப்பட்டது",
  failedToCreateDebitNote: "டெபிட் குறிப்பை வழங்க முடியவில்லை",
  failedToLoadDebitNotes: "டெபிட் குறிப்புகளை ஏற்ற முடியவில்லை",
  failedToLoadDebitNote: "டெபிட் குறிப்பை ஏற்ற முடியவில்லை",
  failedToApplyDebitNote: "டெபிட் குறிப்பைப் பயன்படுத்த முடியவில்லை",
  failedToCancelDebitNote: "டெபிட் குறிப்பை ரத்து செய்ய முடியவில்லை",
  someFieldsRequired: "சமர்ப்பிக்கும் முன் முன்னிலைப்படுத்தப்பட்ட புலங்களைச் சரிசெய்யவும்",
  supplierRequired: "சப்ளையரைத் தேர்ந்தெடுக்கவும்",
  purchaseOrderRequired: "கொள்முதல் ஆர்டரைத் தேர்ந்தெடுக்கவும்",
  amountMustBePositive: "தொகை பூஜ்ஜியத்தை விட அதிகமாக இருக்க வேண்டும்",
  applyAmountExceedsRemaining: "பயன்படுத்தும் தொகை மீதமுள்ள நிலுவையை மீற முடியாது",
  reasonRequired: "காரணத்தை உள்ளிடவும்",
  noDebitNotesFound: "டெபிட் குறிப்புகள் எதுவும் இல்லை",
  noDebitNotesYet: "இன்னும் டெபிட் குறிப்புகள் இல்லை.",
  noDebitNotesFoundDescription: "உங்கள் தற்போதைய வடிப்பான்களுடன் பொருந்தும் டெபிட் குறிப்புகள் இல்லை",
  noDebitNotesYetDescription: "கொள்முதல் ஆர்டருக்கு எதிராக சப்ளையர் வரவைப் பதிவு செய்ய உங்கள் முதல் டெபிட் குறிப்பை வழங்கவும்.",
  issueFirstDebitNote: "முதல் டெபிட் குறிப்பை வழங்கவும்",
};
